//
//
//
//
//
//

export default {
  name: 'PictureShow',
  data() {
    return {
      img: '',
      show: false
    }
  },
  mounted() {
    this.img = this.$route.params.img
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/components/PictureShow.vue